import PropTypes from 'prop-types';
import React from 'react';

const InfoIcon = ({ size, style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
      <path d="M12 9h.01" />
      <path d="M11 12h1v4h1" />
    </svg>
  );
};

InfoIcon.propTypes = {
  size: PropTypes.number,
  style: PropTypes.objectOf(PropTypes.any),
};

InfoIcon.defaultProps = {
  size: 12,
  style: {},
};

export default InfoIcon;
